import { Typography } from 'antd'
import { FC } from 'react'
import './index'

type TitleProps = typeof Typography.Title.defaultProps

export const SubTitle: FC<TitleProps> = (props) => <Typography.Title type={'secondary'} {...props} />

export const Title: FC<TitleProps> = (props) => <Typography.Title {...props} />
